.iframe {
  border: 0;
  display: block;
  max-height: calc(100vh - var(--mirai-ui-space-L) * 4);
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  width: 100%;
}

.redirecting {
  align-items: center;
  display: flex;
  gap: var(--mirai-ui-space-M);
  justify-content: center;
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
}
